export enum ProgramActivationStatusEnum {
  AwaitingEventDate = 0,
  Scheduled = 1,
  Active = 2,
}

export interface IPatientProgram {
  id: number;
  patientID: number;
  healthcareFacilityID: number;
  carePlanTemplateID: number;
  carePlanNameEn: string;
  carePlanNameFr: string;
  eventDate: Date | null;
  eventLabelEn: string | null;
  eventLabelFr: string | null;
  activationStatus: ProgramActivationStatusEnum;
  day0Date: Date | null;
  activationMethod: string | null;
  consentGateClearedDate: Date | null;
}

export interface IPatientProgramModel {
  id: number;
  patientID: number;
  healthcareFacilityID: number;
  carePlanTemplateID: number;
  carePlanNameEn: string;
  carePlanNameFr: string;
  eventDate: string | null;
  eventLabelEn: string | null;
  eventLabelFr: string | null;
  activationStatus: number;
  day0Date: string | null;
  activationMethod: string | null;
  consentGateClearedDate: string | null;
}

export class PatientProgram implements IPatientProgram {
  public id: number;
  public patientID: number;
  public healthcareFacilityID: number;
  public carePlanTemplateID: number;
  public carePlanNameEn: string;
  public carePlanNameFr: string;
  public eventDate: Date | null;
  public eventLabelEn: string | null;
  public eventLabelFr: string | null;
  public activationStatus: ProgramActivationStatusEnum;
  public day0Date: Date | null;
  public activationMethod: string | null;
  public consentGateClearedDate: Date | null;

  constructor(model: IPatientProgramModel) {
    this.id = model.id;
    this.patientID = model.patientID;
    this.healthcareFacilityID = model.healthcareFacilityID;
    this.carePlanTemplateID = model.carePlanTemplateID;
    this.carePlanNameEn = model.carePlanNameEn;
    this.carePlanNameFr = model.carePlanNameFr;
    this.eventDate = model.eventDate ? new Date(model.eventDate) : null;
    this.eventLabelEn = model.eventLabelEn;
    this.eventLabelFr = model.eventLabelFr;
    this.activationStatus = model.activationStatus as ProgramActivationStatusEnum;
    this.day0Date = model.day0Date ? new Date(model.day0Date) : null;
    this.activationMethod = model.activationMethod;
    this.consentGateClearedDate = model.consentGateClearedDate
      ? new Date(model.consentGateClearedDate)
      : null;
  }
}
